// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2hcvJ","label":"Radio_label__2q4_f","checkMark":"Radio_checkMark__2USlH","disabled":"Radio_disabled__2yBPX"};